<!-- <p>visitor-dashboard-table works!</p> -->
<mat-card
  [ngClass]="{
    'visitor-table-card':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'visitor-table-card-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card-header *ngIf="showHeader" class="visitor-table-card-header">
    <div
      [ngClass]="{
        'visitor-table-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
        'visitor-table-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      <div
        [ngClass]="{
          'visitor-table-header-inner': screenSize == ScreenType.Mobile,
          'visitor-table-header-inner-desktop':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
        }"
      >
        <h2>RECENT VISITOR</h2>
        <div
          *ngIf="role == 'security'"
          class="manual-add"
          (click)="onCreateVisitorGateEntry()"
        >
          <mat-icon>add_circle_outline</mat-icon>
          <h4>ADD GATE ENTRY</h4>
        </div>
        <!-- <div (click)="downloadCSV()" class="manual-add">
          <mat-icon>download</mat-icon>

          <h4>DOWNLOAD CSV</h4>
        </div> -->
        <div class="search-box-container">
          <mat-form-field
            [ngStyle]="
              screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
            "
            subscriptSizing="dynamic"
            appearance="outline"
          >
            <mat-label>Visitor Status</mat-label>

            <mat-select
              [value]="selectedStatus"
              (selectionChange)="onChangeDataTable($event)"
            >
              <mat-option value="-1">All</mat-option>
              <mat-option value="0">Unverified</mat-option>
              <mat-option value="1">Verified</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input />
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content
    class="visitor-table-card-content"
    [ngStyle]="!showHeader ? { 'margin-top': '5px', padding: '0' } : {}"
  >
    <div
      class="visitors-table"
      *ngIf="screenSize != ScreenType.Mobile && showHeader"
    >
      <!-- <mat-paginator
        [pageSizeOptions]="[2, 5, 10, 15, 25, 50, 100]"
        [pageSize]="10"
        aria-label="Select page of visitor"
      ></mat-paginator> -->
      <table
        mat-table
        [dataSource]="filteredDataSource"
        matSort
        multiTemplateDataRows
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
      >
        <!-- <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef>No</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ i + 1 }}
          </td>
        </ng-container> -->
        <ng-container matColumnDef="name">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Name
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.firstName + " " + row.lastName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Date
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.visitDateTime | date : "full" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="time">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Time
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ getFormatedDate(row.visitDateTime) | date : "hh:mm a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="host">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Host
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.hostName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="purpose">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Purpose
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.purpose ? row.purpose : "Not Mentioned" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="security">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Security
          </th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let row"
          >
            <button
              [ngStyle]="
                row.securityStatus == 1 ||
                row.securityStatus == 4 ||
                row.securityStatus == 5
                  ? { 'background-color': 'green' }
                  : row.securityStatus == -1 || row.securityStatus == 3
                  ? { 'background-color': '#FFBF00' }
                  : row.securityStatus == 11
                  ? { 'background-color': '#FFBF00' }
                  : { 'background-color': 'red' }
              "
              class="security-button"
              mat-raised-button
            >
              {{
                row.securityStatus == 0
                  ? "Unverified"
                  : row.securityStatus == 1
                  ? "Verified"
                  : row.securityStatus == -1
                  ? "Rejected"
                  : row.securityStatus == 3
                  ? "Auto Rejected"
                  : row.securityStatus == 4
                  ? "In Progress"
                  : row.securityStatus == 5
                  ? "Completed"
                  : "Pending"
              }}
              <!-- {{
                row.securityStatus == -1
                  ? "Rejected"
                  : (row.securityStatus == 1 ||
                      row.securityStatus == 4 ||
                      row.securityStatus == 5) &&
                    row.isPreApproved != "true"
                  ? "Verified"
                  : row.securityStatus == 1 && row.isPreApproved == "true"
                  ? "Pre-Approved"
                  : row.securityStatus == 3
                  ? "Auto Rejected"
                  : row.securityStatus == 0 && row.isPreApproved == "true"
                  ? "Pre-Approved"
                  : row.securityStatus == 11
                  ? "Manually Verified"
                  : "Pending"
              }} -->
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="Details">
          <th
            style="text-align: center"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          >
            Details
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            <button
              [disabled]="isShowDetails && expandedDetail == element.visitorID"
              (click)="onShowDetails(element)"
              mat-raised-button
            >
              <mat-icon *ngIf="expandedDetail != element.visitorID"
                >add</mat-icon
              >
              <mat-icon
                *ngIf="isShowDetails && expandedDetail == element.visitorID"
                >remove</mat-icon
              >
            </button>
          </td>
        </ng-container>
        <tr
          class="table-header"
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <div class="not-matched" *ngIf="!!filteredDataSource && !!temp.length">
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter</td>
          </tr>
        </div>
      </table>
      <div class="data-not-found" *ngIf="!temp.length">
        {{ "No visitor Data available" | uppercase }}
      </div>
    </div>
    <div
      class="visitor-table-mobile"
      [ngStyle]="!showHeader ? { 'margin-top': '5px' } : {}"
      *ngIf="screenSize === ScreenType.Mobile || !showHeader"
    >
      <app-mobile-table-card
        [visitorTableData]="filteredDataSource.data"
        [isSecurity]="true"
        [tableType]="'visitor'"
        (showDetails)="onShowDetails($event)"
        (showPreApprovedAction)="onActionPreApproved($event)"
      ></app-mobile-table-card>
    </div>
  </mat-card-content>
</mat-card>
